import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import TFDVChart from 'components/Meteorology/Agro/TrackingForecast/DetailedView/Chart';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function FullscreenChart({
  open,
  dismiss,
}: {
  open: boolean;
  dismiss: () => void;
}) {
  if (!open) return null;

  return (
    <div className="agro-tf-dv-fullscreen-overlay">
      <button
        type="button"
        aria-label="Sair do modo tela cheia"
        className="agro-tf-dv-fullscreen-close"
        onClick={dismiss}
      >
        <Icon iconType="close" color={cssVar('text-strong')} />
      </button>
      <div className="agro-tf-dv-fullscreen-rotate">
        <div className="agro-tf-dv-fullscreen-chart">
          <TFDVChart />
        </div>
      </div>
      <span className="agro-tf-dv-fullscreen-caption">
        Modo paisagem · toque no X para sair
      </span>
    </div>
  );
}
